'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _translate = _interopRequireDefault(require("./../translate"));
var _advancedFetch = _interopRequireDefault(require("./../../lib/advanced-fetch"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
var MetaNav = /*#__PURE__*/function (_React$Component) {
  _inherits(MetaNav, _React$Component);
  function MetaNav(props) {
    var _this;
    _classCallCheck(this, MetaNav);
    _this = _possibleConstructorReturn(this, (MetaNav.__proto__ || Object.getPrototypeOf(MetaNav)).call(this, props));
    _this.openLangSelect = _this.openLangSelect.bind(_assertThisInitialized(_this));
    _this.changeLanguage = _this.changeLanguage.bind(_assertThisInitialized(_this));
    _this.state = {
      isLangSelectOpen: false,
      language: _this.props.i18n.language || ''
    };
    return _this;
  }
  _createClass(MetaNav, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "meta-nav"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "lang-select"
      }, /*#__PURE__*/_react.default.createElement("div", {
        onClick: this.openLangSelect
      }, /*#__PURE__*/_react.default.createElement("span", null, this.state.language.toUpperCase()), /*#__PURE__*/_react.default.createElement("i", {
        className: "arrow-icon"
      })), this.state.isLangSelectOpen ? /*#__PURE__*/_react.default.createElement("ul", {
        className: "lang-list"
      }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        className: this.state.language === 'de' ? 'is-active' : '',
        onClick: function onClick(e) {
          return _this2.changeLanguage(e, 'de');
        },
        href: ""
      }, "DE")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        className: this.state.language === 'en' ? 'is-active' : '',
        onClick: function onClick(e) {
          return _this2.changeLanguage(e, 'en');
        },
        href: ""
      }, "EN")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        className: this.state.language === 'fr' ? 'is-active' : '',
        onClick: function onClick(e) {
          return _this2.changeLanguage(e, 'fr');
        },
        href: ""
      }, "FR"))) : null), /*#__PURE__*/_react.default.createElement("a", {
        className: "meta-link",
        href: t('contact-link'),
        rel: "noreferrer noopener",
        target: "_blank"
      }, t('Contact')));
    }
    /**
     *
     */
  }, {
    key: "openLangSelect",
    value: function openLangSelect() {
      this.setState(function (prev) {
        return {
          isLangSelectOpen: !prev.isLangSelectOpen
        };
      });
    }
    /**
     *
     * @param e
     * @param lang
     */
  }, {
    key: "changeLanguage",
    value: function changeLanguage(e, lang) {
      var _this3 = this;
      e.preventDefault();
      fetch('api/change-language', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          lang: lang
        })
      }).then(_advancedFetch.default).then(function () {
        _this3.props.i18n.changeLanguage(lang);
        _this3.setState(function (prev) {
          prev.language = lang;
          return prev;
        });
        _this3.openLangSelect();
      });
    }
  }]);
  return MetaNav;
}(_react.default.Component);
MetaNav.propTypes = {
  t: _propTypes.default.func,
  i18n: _propTypes.default.shape({
    changeLanguage: _propTypes.default.func,
    language: _propTypes.default.string
  })
};
var _default = (0, _translate.default)(MetaNav);
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/meta-nav/index.js
// module id = 466
// module chunks = 0